/* eslint-disable */
import View from './view';

export default class PanelView extends View {
    constructor(controller, container, config) {
        super(controller, container, config);
        this.template = this.config.template || '<div class="tooltip"><span class="tooltip__name">{{name}}</span>';
        this.model = this.config.model;
        this.canHover = this.config.canHover;

        this.el = document.createElement('div');
        this.baseClassName = 'map__tooltip-view';
        this.offsetFromCursor = [15, 15];

        // @todo ? decouple controller and views like the following (i.e. where this === Controller, this.attachView(new View()) reads this and does this.addTopicHandler() for each key)
        // this.topicHandlers = {
        //     'hover-feature': this.handleHoverFeature.bind(this),
        //     'unhover-feature': this.handleUnhoverFeature.bind(this),
        //     'mousemove-feature': this.handleMouseMove.bind(this),
        // };
        controller.addTopicHandler('hover-feature', this.handleHoverFeature.bind(this));
        controller.addTopicHandler('unhover-feature', this.handleUnhoverFeature.bind(this));
        controller.addTopicHandler('mousemove-feature', this.handleMouseMove.bind(this));
    }

    render() {
        this.el.className = this.baseClassName;
        this.el.style.position = 'absolute';
        this.el.style.pointerEvents = 'none';
        this.el.style.top = 0;
        this.el.style.left = 0;
        this.container.appendChild(this.el);
        this.hide();
    }

    handleMouseMove(event) {
        this.updatePosition(event.position);
    }

    handleUnhoverFeature() {
        this.hide();
    }

    handleHoverFeature(event) {
        const data = event.feature;
        if (data.id === null) {
            this.hide();
        }
        else {
            this.updateText(data);
            this.show();
        }
    }

    updateText(data) {
        const innerHTML = this.parseTemplate([data.properties, data.properties.values, data.properties.extras]);
        this.el.innerHTML = innerHTML;
    }

    updatePosition(coords) {
        const viewPadding = 3;
        const rawLeft = coords[0] || 0;
        const rawTop = coords[1] || 0;
        const tooltipDimensions = [this.getElementWidth(this.el), this.getElementHeight(this.el)];
        const mapViewDimensions = [this.getElementWidth(this.container), this.getElementHeight(this.container)];

        const position = [rawLeft + this.offsetFromCursor[0], rawTop + this.offsetFromCursor[1]];

        for (let i = 0; i < position.length; i++) {
            if (position[i] + tooltipDimensions[i] + viewPadding > mapViewDimensions[i]) {
                position[i] -= tooltipDimensions[i] + (1.5 * this.offsetFromCursor[i]);
            }
        }

        this.el.style.left = `${position[0]}px`;
        this.el.style.top = `${position[1]}px`;
    }

    getElementWidth(el) {
        return el.getBoundingClientRect().right - el.getBoundingClientRect().left;
    }

    getElementHeight(el) {
        return el.getBoundingClientRect().bottom - el.getBoundingClientRect().top;
    }

    show() {
        if (this.canHover) {
            this.el.style.visibility = 'visible';
            this.el.style.transition = 'opacity 0.25s linear';
            this.el.style.opacity = 1;
        }
    }

    hide() {
        this.el.style.visibility = 'hidden';
        this.el.style.transition = 'opacity 0s linear';
        this.el.style.opacity = 0;
    }

    parseTemplate(templateDataset) {
        let contentHTML = this.template;

        const data = {};
        for (let i = 0; i < templateDataset.length; i++) {
            const templateData = templateDataset[i];
            Object.assign(data, templateData);
        }

        Object.keys(data).forEach((key) => {
            if (typeof data[key] === 'string' || typeof data[key] === 'number') {
                contentHTML = contentHTML.replace(`{{${key}}}`, data[key]);
            }
        });

        contentHTML = contentHTML.replace(/{{([A-Z])\w+}}/gi, '');

        return contentHTML;
    }
}
